<template>
  <div class="buttons are-medium">
    <button class="button is-success is-rounded" @click="download('win')">
      <span class="icon">
        <font-awesome-icon :icon="['fas', 'download']" />
      </span>
      <span>
        Download for Windows
      </span>
    </button>
    
    <button class="button is-rounded"  @click="exploreGit()">
      <span class="icon">
        <font-awesome-icon :icon="['fab', 'github']" />
      </span>
      <span>
        Explore on GitHub
      </span>
    </button>

    
    <div class="notification is-link mt-3">
      This is a preview build, you may encounter some bugs or unexpected behaviour <br>
      You can <a href="https://github.com/DavG25/discord-richer-presence/issues" rel="noopener">open an issue on GitHub</a> or <a href="https://www.davg25.com/home/#email" targer="_new">send feedback via email</a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      downloadURLs: {
        "win": "https://github.com/DavG25/discord-richer-presence/releases/download/v1.0.1-alpha/Discord.Richer.Presence.Setup.1.0.1-alpha.exe"
      },
      repoURL: "https://github.com/DavG25/discord-richer-presence/"
    }
  },
  methods: {
    download(platform) {
      window.open(this.downloadURLs[platform], '_blank')
    },
    exploreGit() {
      window.open(this.repoURL, '_blank', 'noopener')
    }
  },
}
</script>